import { PostFormData } from '@buildwise/pages/addPost/hooks/useAddPostForm';
import { Box, FormControl, TextField } from '@mui/material';
import { ConfigEntryType } from 'config/config';
import { theme } from 'config/theme';
import { Controller, useFormContext } from 'react-hook-form';

type HelpCenterCollectionTitleFieldProps = {
  field: ConfigEntryType;
  isEditing?: boolean;
};
const HelpCenterCollectionTitleField = ({
  field,
  isEditing = false,
}: HelpCenterCollectionTitleFieldProps) => {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<PostFormData>();
  return (
    <Box sx={{ mb: isEditing ? 3 : 0 }}>
      <Controller
        control={control}
        render={({ field: _field, fieldState }) => (
          <FormControl fullWidth>
            <TextField
              {..._field}
              value={!!_field?.value?.trim() ? _field.value : ''}
              error={!!fieldState.error}
              helperText={fieldState.error?.message || ''}
              fullWidth
              autoFocus={!isEditing}
              label={'Title'}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
                sx: { fontWeight: 700, color: theme.palette.custom.tuna },
              }}
              disabled={isSubmitting}
              placeholder={field.referenceObject?.placeHolder || 'Enter value'}
            />
          </FormControl>
        )}
        name={field.entryCode}
      />
    </Box>
  );
};

export default HelpCenterCollectionTitleField;
